import { featureFlags } from "../FeatureFlags";
import { createLazyPage, wrapElement } from "./utils.js";

const AcceptInvitationPage = createLazyPage("LoginPage", "AcceptInvitationPage");
const DashboardPage = createLazyPage("DashboardPage", "DashboardPage");

const RegisterPage = createLazyPage("RegisterPage", "RegisterPage");

const IndexResources = createLazyPage("ResourcesPage", "IndexResources");
const ShowResources  = createLazyPage("ResourcesPage", "ShowResources");
const CreateResources = createLazyPage("ResourcesPage", "CreateResources");
const EditResources  = createLazyPage("ResourcesPage", "EditResources");

const AnalyticsPage   = createLazyPage("AnalyticsPage",  "AnalyticsPage");
const IndexInvoices   = createLazyPage("InvoicesPage",   "IndexInvoices");
const ShowInvoice     = createLazyPage("InvoicesPage",   "ShowInvoice");
const CreateInvoice   = createLazyPage("InvoicesPage",   "CreateInvoice");

export const webRoutes = [
	{ path: "/dashboard", element: wrapElement(DashboardPage), enabled: true },
	// Analytics
	// Invoices
	{ path: "/invoices",            element: wrapElement(IndexInvoices),  enabled: true },
	{ path: "/invoices/create",     element: wrapElement(CreateInvoice), enabled: true },
	{ path: "/invoices/:id",        element: wrapElement(ShowInvoice),   enabled: true },

	{ path: "/analytics",           element: wrapElement(AnalyticsPage), enabled: true },
	{ path: "/analytics/projects",  element: wrapElement(AnalyticsPage), enabled: true },
	{ path: "/analytics/quotes",    element: wrapElement(AnalyticsPage), enabled: true },
	{ path: "/analytics/clients",   element: wrapElement(AnalyticsPage), enabled: true },
	{ path: "/analytics/resources", element: wrapElement(AnalyticsPage), enabled: true },
	{
		path: "/register",
		element: wrapElement(RegisterPage),
		enabled: featureFlags.betaLoginPage,
	},
	// Resources (people)
	{ path: "/resources",         element: wrapElement(IndexResources),  enabled: true },
	{ path: "/resources/create",  element: wrapElement(CreateResources), enabled: true },
	{ path: "/resources/:id",     element: wrapElement(ShowResources),   enabled: true },
	{ path: "/resources/:id/edit",element: wrapElement(EditResources),   enabled: true },
	// Public — invitation acceptance (no auth required)
	{ path: "/invite/accept", element: wrapElement(AcceptInvitationPage, false), enabled: true },
];